module.exports = __webpack_public_path__ + "static/media/May_2026_2.0f7dcc0a.webp";